<script>
	import {Form} from '../../helpers/Form/Form'

	export default {
		data() {
			return {
				room: null,
				users: [],
				mails: [],
				editor: null,
				fetch: new Form({
					id: null,
					term: null,
				}),
				form: new Form({
					subject: null,
					message: null,
					recipients: [],
					mail_id: null,
					send_all: false
				})
			}
		},
		watch: {
			'fetch.term': {
				handler(val) {
					this.searchUser(this)
				}
			}
		},
		mounted() {
			this.initModal()
			this.initEditor()

			this.$bus.$on('rooms:notification:show', this.load)
		},
		updated() {
			this.initEditor()

			var ps_todo_collection = new PerfectScrollbar(this.$refs.collection, {
				theme: "dark",
				suppressScrollX: true, 
				maxScrollbarLength: 200
			});

			$("select").formSelect();
		},
		methods: {
			searchUser: _.debounce((vm) => {
				vm.fetchUsers()
			}, 500),
			async load(payload) {
				this.$set(this, 'room', payload)

				await this.fetchUsers()
				await this.fetchMails()

				$(this.$refs.modal).modal('open')
			},
			async fetchUsers() {
				await this.fetch
					.get(route('api.users.list'))
					.then(response => {
						this.$set(this, 'users', response.data)
					})
			},
			async fetchMails() {
				await this.fetch
					.get(route('api.mails.list'))
					.then(response => {
						this.$set(this, 'mails', response.mails)
					})
			},
			initModal() {
				$(this.$refs.modal).modal()
			},
			initEditor() {
				if ($(".ql-toolbar").length) {
					return
				}

				this.editor = new Quill(this.$refs.editor, {
					bounds: this.$refs.editor,
					modules: {
					  	'formula': true,
					  	'syntax': true,
					  	'toolbar': {
					  		container: [
							    [{'font': []}, {'size': []}],
						    	['bold', 'italic', 'underline', 'strike'],
						    	[{'color': []}, {'background': []}],
						    	[{'script': 'super'}, {'script': 'sub'
						    	}],
						    	[{'header': '1'}, {'header': '2'}, 'blockquote', 'code-block'],
						    	[{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
						    	['direction', {'align': []}],
						    	['link', 'image', 'video', 'formula'],
						    	['clean'],
						    	['emoji']
					  		],		  		
					  	},
						'emoji-toolbar': true,
						'emoji-shortname': true,			  	
					},
					theme: 'snow'
				});
				// add browser default class to quill select 
				let quillSelect = $("select[class^='ql-'], input[data-link]");
				quillSelect.addClass("browser-default");

		        this.editor.on('text-change', (e) => {
			    	this.$set(this.form, 'message', this.editor.root.innerHTML);
			    });		

			    this.editor.root.innerHTML = this.form.message
			},
			onSubmit() {
				this.form
					.submit('post', route('api.rooms.notifications', this.room))
					.then(response => {
						$(this.$refs.modal).modal('close')

						this.$swal({
							icon: 'success',
							text: 'Notifica inviata correttamente'			
						})			

						this.editor.root.innerHTML = this.form.message				
					})
			}
		}
	}
</script>